






























































import { vxm } from '../../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'Unsubscribe',
  components: {},
})
export default class Unsubscribe extends Vue {
  $wlToastr: any;
  private confirmDisplayMessage: string =
    'Would you like to unsubscribe from all email notifications?';
  private unsubscribeMessage: string = '';
  private showConfirmButton: boolean = false;
  private data: any;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public unsubscribeTheNotification() {
    vxm.users.unsubscribeTheNotification(this.data['userId']).then((res) => {
      console.log('Unsubscribe Notification -- ' + res);
      this.unsubscribeMessage = res;
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public unsubscribeRequestValid(data) {
    vxm.users.isUnsubscribeRequestValid(data).then((res) => {
      console.log('res -- ' + res);
      if (res) {
        this.showConfirmButton = true;
      } else {
        this.showConfirmButton = false;
        this.$router.push('login');
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mounted() {
    const phoneValidationCode = this.$route.query.phoneValidationCode + '';
    //userId=1154&email=mtalikoti@workllama.com&uuid=bw67astc%2FWpmaQT3RbQT9zKgPV8pQFhyCFVN4G67sZ0%3D;

    const userId = this.$route.query.userId;
    const email = this.$route.query.email;
    const uuid = this.$route.query.uuid;
    this.data = { userId: userId, email: email, uuid: uuid };
    this.unsubscribeRequestValid(this.data);
  }
}
